import Portal from "./Portal";

export {
    Portal as default,
};